/**
 * @generated SignedSource<<587be09368dd9d423f4291c037d30002>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CustomerCategoryIndicatorNoCategoryStylePreference = "NONE" | "OUTLINE" | "%future added value";
export type CustomerOverviewAdditionalInfoPreference = "NONE" | "RECOMMENDED_CHECKS" | "REQUIRED_CHECKS" | "STATISTICS" | "%future added value";
export type DashboardStatisticsGraphAdditionalInfoPreference = "LAST_YEAR" | "MOVING_AVERAGE_EIGHT_WEEKS" | "MOVING_AVERAGE_TWELVE_WEEKS" | "NONE" | "REGRESSION" | "%future added value";
export type FeatureFlagKey = "alerts" | "calls" | "christmas" | "customerLocations" | "darkMode" | "halloween" | "insightsDailyQuarterHourlyHistogram" | "live" | "monthlyCustomerBillings" | "search" | "snake" | "subscriptionActivityButton" | "timeTrackDescription" | "tips" | "%future added value";
export type NavigationItemWorkspaceDestinationPreference = "ALL_USERS" | "CURRENT_USER" | "%future added value";
export type WorkspaceLayoutPreference = "COMPACT" | "EXPANDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ViewerContext_viewer$data = {
  readonly canApproveTimeTracks: boolean;
  readonly canCreateTokenForAllUsers: boolean;
  readonly canEditCustomerBaseData: boolean;
  readonly canEditOrganization: boolean;
  readonly canViewCustomerBillings: boolean;
  readonly canViewFullTimeTrackList: boolean;
  readonly canViewHourlyRates: boolean;
  readonly canViewLastTwoWeeksTimeTrackList: boolean;
  readonly canViewOthersPermissions: boolean;
  readonly canViewStatistics: boolean;
  readonly canViewTimeTrackEvents: boolean;
  readonly customerCategoryIndicatorNoCategoryStylePreference: CustomerCategoryIndicatorNoCategoryStylePreference;
  readonly customerOverviewAdditionalInfoPreference: CustomerOverviewAdditionalInfoPreference;
  readonly dashboardStatisticsGraphAdditionalInfoPreference: DashboardStatisticsGraphAdditionalInfoPreference;
  readonly displayName: string;
  readonly email: any | null | undefined;
  readonly emailVerified: boolean | null | undefined;
  readonly employee: {
    readonly displayName: string;
    readonly id: string;
    readonly printName: string;
  } | null | undefined;
  readonly flags: ReadonlyArray<FeatureFlagKey>;
  readonly id: string;
  readonly navigationItemWorkspaceDestinationPreference: NavigationItemWorkspaceDestinationPreference;
  readonly permissionSuperuser: boolean;
  readonly permissionTimeTrackRemove: boolean;
  readonly shouldViewOtherUsers: boolean;
  readonly username: string;
  readonly workspaceLayoutPreference: WorkspaceLayoutPreference;
  readonly " $fragmentType": "ViewerContext_viewer";
};
export type ViewerContext_viewer$key = {
  readonly " $data"?: ViewerContext_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewerContext_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewerContext_viewer",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "username",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailVerified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workspaceLayoutPreference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dashboardStatisticsGraphAdditionalInfoPreference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerOverviewAdditionalInfoPreference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "navigationItemWorkspaceDestinationPreference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerCategoryIndicatorNoCategoryStylePreference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canApproveTimeTracks",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewStatistics",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shouldViewOtherUsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewHourlyRates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewOthersPermissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewCustomerBillings",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEditCustomerBaseData",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewFullTimeTrackList",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewLastTwoWeeksTimeTrackList",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canViewTimeTrackEvents",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEditOrganization",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canCreateTokenForAllUsers",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionTimeTrackRemove",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissionSuperuser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flags",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "printName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ViewerUser",
  "abstractKey": null
};
})();

(node as any).hash = "16cfb9ab44c792ddaf024c7a52f24f22";

export default node;
